import { ViewerProvider, useViewer } from '@/features/viewer/ViewerContext';
import { ViewerCanvas } from '@/features/viewer/ViewerCanvas';
import { useShortcuts } from '@/features/viewer/useShortcuts';
import { TopBar } from '@/features/chrome/TopBar';
import { LoadOverlay } from '@/features/chrome/LoadOverlay';
import { Toaster } from '@/features/chrome/Toaster';
import { EmptyState } from '@/features/chrome/EmptyState';
import { StatusBar } from '@/features/chrome/StatusBar';
import { Toolbar } from '@/features/toolbar/Toolbar';
import { FileDropOverlay } from '@/features/file/FileDropOverlay';
import { useFileDrop } from '@/features/file/useFileDrop';
import { PropertiesPanel } from '@/features/properties/PropertiesPanel';
import { ModelTreePanel } from '@/features/tree/ModelTreePanel';
import { MeasureOverlay } from '@/features/measure/MeasureOverlay';
import { SectionPanel } from '@/features/section/SectionPanel';
import { ViewCube } from '@/features/viewcube/ViewCube';

function Workspace() {
  const { loadFile } = useViewer();
  const dragOver = useFileDrop((file) => void loadFile(file));
  useShortcuts();

  return (
    <div className="relative h-full w-full">
      <ViewerCanvas />
      <Toolbar />
      <TopBar />
      <ModelTreePanel />
      <ViewCube />
      <SectionPanel />
      <MeasureOverlay />
      <PropertiesPanel />
      <StatusBar />
      <EmptyState />
      <FileDropOverlay visible={dragOver} />
      <LoadOverlay />
      <Toaster />
    </div>
  );
}

export function App() {
  return (
    <ViewerProvider>
      <Workspace />
    </ViewerProvider>
  );
}
